import { useState } from "react";

import { OrderQueuesList } from "./OrderQueuesList";
import { OrderQueueDetails } from "./OrderQueueDetails";

export const OrderQueuesPanel = () => {
  const [selectedQueueId, setSelectedQueueId] = useState<string | null>(null);

  const selectQueue = (id: string) => {
    setSelectedQueueId(id);
  };

  return !selectedQueueId ? (
    <OrderQueuesList selectQueue={selectQueue} />
  ) : (
    <OrderQueueDetails
      queueId={selectedQueueId}
      close={() => setSelectedQueueId(null)}
    />
  );
};
